import React, { useState, useEffect } from 'react';
import ProjectCard from './ProjectCard';
import './ProjectGallery.css';

const projectData = [
  { id: 1, title: 'Project A', description: 'Description of Project A', category: 'React' },
  { id: 2, title: 'Project B', description: 'Description of Project B', category: 'Php' },
  { id: 3, title: 'Project C', description: 'Description of Project C', category: 'Php' },
  { id: 4, title: 'Project D', description: 'Description of Project D', category: 'React' },
  { id: 5, title: 'Project E', description: 'Description of Project E', category: 'React' },
];

const categories = ['All', 'React', 'Php'];

const ProjectGallery = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [filteredProjects, setFilteredProjects] = useState(projectData);

  useEffect(() => {
    const filtered =
      activeCategory === 'All'
        ? projectData
        : projectData.filter((project) => project.category === activeCategory);

    // Add delay for animation by setting a timeout before updating the state
    const timeout = setTimeout(() => {
      setFilteredProjects(filtered);
    }, 300); // Matches animation duration

    return () => clearTimeout(timeout);
  }, [activeCategory]);

  return (
    <div className="gallery-container">
      <div className="category-buttons">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setActiveCategory(category)}
            className={activeCategory === category ? 'active' : ''}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="project-grid">
        {filteredProjects.map((project, index) => (
          <ProjectCard
            key={project.id}
            project={project}
            animationDelay={index * 0.2} // Add delay for each card
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectGallery;
